/** Custom-event names `AbstractTileComponent`'s Edit/Delete buttons `fire()`
 *  (`AbstractLitElement.fire()`) — mirrors `DialogCommandName`'s role as a
 *  shared vocabulary between sender (`AbstractTileComponent`) and listener
 *  (`dashboard-creator.component.ts`'s `_mountTile()`), instead of two loose
 *  string literals that could drift apart. */
export enum TileEventName {
    EDIT = 'tile.edit',
    DELETE = 'tile.delete',
}
